import React, { useState } from "react";
import { usePayment } from "../hooks";
import { Box, Grid, Typography, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { emailRegex } from "../constants";

/**
 * @deprecated Superseded by DepositFundTemplate, which owns amount entry (D-04).
 * Kept compiling rather than deleted so the way back from the rewrite is not a
 * revert on a live payment path; removal is TODO-245, homed in Phase 15.
 */
const PaymentForm: React.FC = () => {
  const { t } = useTranslation();
  const { amount, setAmount, name, setName, email, setEmail } = usePayment();
  const [amountError, setAmountError] = useState("");
  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");

  const handleAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.replace(/[^0-9]/g, "");
    setAmount(value);

    if (value === "") {
      setAmountError(
        t("payment.form.errors.amount_required", "Le montant est requis")
      );
    } else if (parseInt(value) < 100) {
      setAmountError(
        t(
          "payment.form.errors.min_amount",
          "Le montant minimum est de 100 FCFA"
        )
      );
    } else {
      setAmountError("");
    }
  };

  const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setName(value);

    if (value.trim() === "") {
      setNameError(t("payment.form.errors.name_required", "Le nom est requis"));
    } else {
      setNameError("");
    }
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.trim();
    setEmail(value);
    if (value === "") {
      setEmailError(
        t("payment.form.errors.email_required", "L'email est requis")
      );
    } else if (!emailRegex.test(value)) {
      setEmailError(
        t("payment.form.errors.email_invalid", "L'email n'est pas valide")
      );
    } else {
      setEmailError("");
    }
  }

  return (
    <Box mb={4}>
      <Typography variant="h6" fontWeight="bold" mb={2}>
        {t("payment.form.title", "1. Transaction de paiement")}
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            type="text"
            id="amount"
            label={t("payment.form.amount_label", "Montant (FCFA)*")}
            value={amount}
            onChange={handleAmountChange}
            error={!!amountError}
            helperText={
              amountError
                ? amountError
                : t(
                    "payment.form.amount_hint",
                    "Veuillez entrer par multiples de 50 FCFA, minimum 100 FCFA"
                  )
            }
            variant="outlined"
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            type="text"
            id="name"
            label={`${t("payment.form.name_label", "Nom*")}*`}
            value={name}
            onChange={handleNameChange}
            error={!!nameError}
            helperText={
              nameError
                ? nameError
                : t(
                    "payment.form.name_hint",
                    "Veuillez entrer votre nom pour référence"
                  )
            }
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            type="email"
            id="email"
            label={`${t("payment.form.email_label", "Email")}*`}
            value={email}
            onChange={handleEmailChange}
            helperText={
              emailError
                ? emailError
                : t(
                    "payment.form.email_hint",
                    "Veuillez entrer votre adresse email pour référence"
                  )
            }
            error={!!emailError}
            variant="outlined"
            sx={{ mt: 2 }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default PaymentForm;
